import "../../Utilities.js";
import "../../Styling.js";
import { memoizeFunction } from "@fluentui/utilities";
import { mergeStyleSets } from "@fluentui/style-utilities";
const getSubscriberPickerClassNames = memoizeFunction(
  (theme, styles) => {
    return mergeStyleSets({
      root: ["ane-SubscriberPicker-root", styles == null ? void 0 : styles.root],
      fieldContainer: [
        "ane-SubscriberPicker-fieldContainer",
        {
          position: "relative"
        },
        styles == null ? void 0 : styles.fieldContainer
      ],
      loadingContainer: [
        "ane-SubscriberPicker-loadingContainer",
        {
          position: "absolute",
          margin: "0 auto",
          /**
           * hack to override stack top margin for child stack items
           */
          marginTop: "0 !important",
          left: "0",
          right: "0"
        },
        styles == null ? void 0 : styles.loadingContainer
      ],
      checkboxContainer: ["ane-SubscriberPicker-checkboxContainer", styles == null ? void 0 : styles.checkboxContainer],
      errorText: [
        "ane-SubscriberPicker-errorText",
        {
          color: theme.palette.redDark,
          fontSize: "12px"
        }
      ]
    });
  }
);
export {
  getSubscriberPickerClassNames
};
//# sourceMappingURL=SubscriberPicker.classNames.js.map
